(function(angular) {
    var privateEndpoints, channelEndpoints, disabledChannels, truncatedChannels, channelUsers, myEndpoint, timeout, rootScope, q, log, _initializing = true;
    var pendingUserJoined = [];

    var parseLocation = function(loc) {
        if (!loc) { return loc; }

        var locElements = loc.split(',');
        var location = {};

        var kv = null;
        for (let e of locElements) {
            kv = e.split('=');
            location[kv[0]] = kv[1];
        }

        return location;
    };

    var addToSet = function(val, set) {
        if(!set.has(val)) {
            set.add(val);
        }
    };

    var removeFromSet = function(val, set) {
        if(set.has(val)) {
            set.delete(val);
        }
    };

    class Endpoint {
        constructor(endpointId) {
            this.id = endpointId;
            this.flags = new Map();
            this.filterIds = [];
            this.locTimeout = null;
            this.userName = '';
            this.name = '';
            this.active = true;
            this.spcActive = false;
            this.Self = false;
        }
    }

    var clearLocation = function (em, endpoint, channelId) {
        endpoint.location = null;
        rootScope.$broadcast("endpointModel.presenceUpdated", channelEndpoints.get(channelId), channelId, endpoint.id, endpoint.userName, []);
        log.debug(`Endpoint ${endpoint.id} location timed out`);
    };

    var _addEndpointToChannel = function(channelId, ep, flags) {
        let usersMap;
        let userNew = false;

        if(!channelEndpoints.has(channelId)) {
            channelEndpoints.set(channelId, new Map());
        }

        if(!channelUsers.has(channelId)) {
            usersMap = new Map();
            channelUsers.set(channelId, usersMap);
        } else {
            usersMap = channelUsers.get(channelId);
        }

        if(!usersMap.has(ep.userName)) {
            usersMap.set(ep.userName, new Map());
            userNew = true;
        }

        channelEndpoints.get(channelId).set(ep.id, ep);
        usersMap.get(ep.userName).set(ep.id, ep);

        if(channelId === 0) {
            ep.spcActive = true;
        }

        // If flags is null then copy from SPC
        _setEndpointsFlags(channelId, ep.id, flags || ep.flags.get(0));

        if(!_initializing && userNew) {
            var _func = function() {
                rootScope.$broadcast('endpointModel.userJoined', channelId, ep);
            };

            if(ep.name) {
                _func();
            }
            else {
                pendingUserJoined.push(_func);
            }
        }
    };

    var _setEndpointsFlags = function(channelId, endpointId, flags) {
        var ep = channelEndpoints.get(channelId).get(endpointId);
        ep.flags.set(channelId, flags);
    }

    // TBD: There is a bug here, when changing channels and there are no new endpoints (but some endpoints on prev channel aren't on selected channel)
    // then presenceUpdated event is not being broadcast
    var updatePropertyWork = function (channelId, ep) {
        var endpoint = privateEndpoints.get(ep.endpointId) || (function (ep) {
            let newEndpoint = new Endpoint(ep.endpointId);

            privateEndpoints.set(ep.endpointId, newEndpoint);
            _setEndpointsFlags(channelId, newEndpoint.id, new WtcpJs.EndpointFlags());

            return newEndpoint;
        })(ep);

        // Sometimes these endpoinst come from channel activity, so we won't have filter ID's
        // Make sure we don't assign a null value to our filter array
        if(ep.filterIds) {
            endpoint.filterIds = ep.filterIds;
        }
        // This shouldn' be happening here, this routine is just for updating EP Props and flags
        //_addEndpointToChannel(channelId, endpoint);

        let em = this;

        for(var prop of Object.getOwnPropertyNames(ep.properties)) {
            switch(prop) {
                case "displayName":

                    // Need to check if this name already been used
                    endpoint.name = ep.properties.displayName;
                    break;
                case "location":
                    if (ep.properties.location) {
                        endpoint.location = parseLocation(ep.properties.location);
                        if (endpoint.locTimeout) {
                            timeout.cancel((endpoint.locTimeout));
                        }

                        endpoint.locTimeout = timeout(clearLocation, 330000, false, em, endpoint, channelId);
                    } else {
                        if (endpoint.locTimeout) {
                            timeout.cancel(endpoint.locTimeout);
                            clearLocation(em, endpoint, channelId);
                        }
                    }
                    break;
                default:
                    // log.debug(`>> Updateing EP ${ep.name},  property ${prop}= value ${ep.properties[prop]}`);
                    endpoint[prop] = ep.properties[prop];
            }
        }

        if(pendingUserJoined.length > 0) {
            pendingUserJoined.pop()();
        }

        return endpoint;
    }

    class EndpointModel {
        constructor($rootScope, $timeout, $q, $log) {
            q = $q;
            rootScope = $rootScope;
            log = $log;
            timeout = $timeout;

            channelEndpoints = new Map();
            disabledChannels = new Set();
            truncatedChannels = new Set();
            channelUsers = new Map();
            privateEndpoints = new Map();
        }
        getEndpoint(endpointId) {
            return privateEndpoints.get(endpointId);
        }
        getChannelEndpoint(channelId, endpointId) {
            if (channelEndpoints.has(channelId)) {
                return channelEndpoints.get(channelId).get(endpointId);
            }
            else {
                return null;
            }
        }
        getEndpoints() {
            return privateEndpoints;
        }

        /**
         * Associate an endpoint with a channel
         * @param [number] channelId
         * @param ep
         * @param flags
         */
        addEndpointToChannel(channelId, ep, flags, silent = false) {
            _addEndpointToChannel(channelId, ep, flags);

            if(!silent) {
                rootScope.$broadcast("endpointModel.presenceUpdated", channelEndpoints.get(channelId), channelId, ep.id, ep.userName, []);
            }
        }
        setEndpointsDisabledOnChannel(channelId, maxEndpointsOnChannel) {
            addToSet(channelId, disabledChannels);
            rootScope.$broadcast("endpointModel.endpointsDisabledOnChannel", channelId, maxEndpointsOnChannel);
        }
        clearEndpointsDisabledOnChannel(channelId) {
            removeFromSet(channelId, disabledChannels);
            rootScope.$broadcast("endpointModel.endpointsEnabledOnChannel", channelId);
        }
        setEndpointsTruncatedOnChannel(channelId) {
            addToSet(channelId, truncatedChannels);
        }
        clearEndpointsTruncatedOnChannel(channelId) {
            removeFromSet(channelId, truncatedChannels);
        }
        endpointsDisabledOnChannel(channelId) {
            return disabledChannels.has(channelId);
        }
        endpointsTruncatedOnChannel(channelId) {
            return truncatedChannels.has(channelId);
        }
        getChannelEndpoints(channelId) {
            if (channelEndpoints.has(channelId)) {
                return channelEndpoints.get(channelId);
            }

            return new Map();
        }
        getChannelUsers(channelId) {
            if (channelUsers.has(channelId)) {
                return channelUsers.get(channelId);
            }

            return new Map();
        }
        // Used to initialize the endpointModel with data
        initializeEndpoints(channelId, resp) {
            _initializing = true;
            var length = resp.endpointPropertyInfo.length;
            var isLastEndpoint = false;
                for (var x = 0; x < length; x++) {
                    let ep = resp.endpointPropertyInfo[x];

                    isLastEndpoint = x !== (length - 1);

                    this.addEndpoint(channelId, ep.endpointInfo.endpointId, ep.endpointInfo.endpointName, ep.endpointInfo.endpointFlags, isLastEndpoint);

                    updatePropertyWork(channelId, {
                        endpointId: ep.endpointInfo.endpointId,
                        properties: ep.endpointProperties,
                        filterIds: [ resp.filterId ]
                    });
                }
                rootScope.$broadcast('endpointModel.endpointsLoaded', channelEndpoints.get(channelId));
            _initializing = false;
        }
        // Used for adding endpoints from onChannelActivity event data
        addEndpoint(channelId, endpointId, name, flags, silent) {
            let ep = privateEndpoints.get(endpointId);
            if(!ep) {
                ep = new Endpoint(endpointId);
                ep.userName = name;
                privateEndpoints.set(endpointId, ep);
            }

            // If endpoints are being added as the result of a setEndpointPropertyFilter there will be no
            // SPC channel activity. This differs from the behavior when an endpoint joins the system
            // and matches an existing endpoint filter. The first sign of this joining user will be activity
            // on the SPC, followed by an add endpoint to the private talk group channel (if there is one).
            // This code adds the endpoint to the SPC channel if it doesn't already exists for consistenncy
            if(channelId < 0 && !channelEndpoints.get(0).has(endpointId)) {
                this.addEndpointToChannel(0, ep, flags, silent); // 0 is the SPC channel
            }

            this.addEndpointToChannel(channelId, ep, flags, silent)

            if (flags.Self) {
                myEndpoint = ep;
                myEndpoint.Self = true;
            }

            return privateEndpoints.get(endpointId);
        }
        // Use to set an initial location on the endpoint, otherwise updateProperties will keep the location up-to-date
        setLocation(endpointId, loc) {
            var _ep = privateEndpoints.get(endpointId);
            if(_ep) {
                _ep.location = parseLocation(`lo=${loc.lng},la=${loc.lat}`);
            } else {
                log.warn(`Failed to setLocation for endpoint id ${endpointId}`);
            }
        }
        // Used for adding or updating endpoints from onEndpointPropertiesReceived event data
        updateProperties(channelId, ep) {
            var endpoint = updatePropertyWork(channelId, ep);

            if(endpoint.name) {
                rootScope.$broadcast("endpointModel.presenceUpdated", channelEndpoints.get(channelId), channelId, endpoint.id, endpoint.userName, ep.filterIds);
            }
        }
        updateFlags(channelId, endpointId, flags) {
            privateEndpoints.get(endpointId).flags.set(channelId, flags);
        }
        deleteEndpoint(channelId, endpointId) {
            if (privateEndpoints.has(endpointId)) {
                let endpoint = privateEndpoints.get(endpointId);
                let endpointMap = channelEndpoints.get(channelId);
                let userName = endpoint.userName;

                let userMap = channelUsers.get(channelId).get(userName);

                let locTimeout = endpoint.locTimeout;
                if (locTimeout) {
                    timeout.cancel(locTimeout);
                }

                if(endpointMap.has(endpointId)) {
                    endpointMap.delete(endpointId);
                }

                if(userMap.has(endpointId)) {
                    userMap.delete(endpointId);
                }

                if(userMap.size === 0) {
                    channelUsers.get(channelId).delete(userName);
                    rootScope.$broadcast('endpointModel.userLeft', channelId, userName, endpoint.filterIds);
                }

                // If endpoint is in contact list, there will be an EP prop update for the user leaving the SPC
                // Defer deleting the endpoint from the private map until channel Id 0 ep prop update comes through
                if(!endpoint.spcActive || channelId === 0) {
                    privateEndpoints.delete(endpointId);
                }

                // This garbage needs to be refactored. Create endpoint joined, endpoints left events...
                rootScope.$broadcast("endpointModel.presenceUpdated", channelEndpoints.get(channelId), channelId, endpointId, userName, endpoint.filterIds);
            }
        }
        getMyEndpoint() {
            return myEndpoint;
        }
        clearChannelEndpoints(channelId) {
            if(channelEndpoints.has(channelId)) {
                channelEndpoints.get(channelId).forEach((ep) => {
                    timeout.cancel(ep.locTimeout);
                });
                channelEndpoints.get(channelId).clear();
            }
            if(channelUsers.has(channelId)) {
                channelUsers.get(channelId).clear();
            }
        }
        clearEndpoints() {
            privateEndpoints.forEach((ep) => {
                timeout.cancel(ep.locTimeout);
            });
            privateEndpoints.clear();
            channelEndpoints.clear();
            channelUsers.clear();
            _initializing = true;
        }
    }

    angular
        .module('webcomm')
        .service('endpointModel', ['$rootScope', '$timeout', '$q', '$log', EndpointModel]);
})(angular);